<template>
    <div>
      <div class="banner">
        <div class="headerReplacementPublishedDocsInfo"></div>
        <div class="banner-text">
          <b>{{ $t('annualReport.pageTitle') }}</b>
          <div class="breadcrumb">
            <span><router-link to="/" class="pe-auto">{{ $t('annualReport.breadcrumbHome') }}</router-link></span>
            <span class="separator"></span>
            <span>{{ $t('annualReport.breadcrumbSection') }}</span>
            <span class="separator"></span>
            <span><b>{{ $t('annualReport.breadcrumbPage') }}</b></span>
          </div>
        </div>
      </div>
  
      <div class="container mb-5">
        <div class="TabMenu">
          <PublishedDocsInfoTabMenu />
        </div>
  
        <div class="row justify-content-center align-items-center mb-5">
          <div class="card card-pdf bg-white mt-5 mb-3">
            <div class="row">
              <div class="col-12 col-md-6 text-center bg-black">
                <img :src="list[0]?.annual_report_img_url" class="img-fluid rounded-start p-3" style="height: 300px;">
              </div>
              <div class="col-md-6 d-flex">
                <div class="vertical-line"></div>
                <div class="card-body">
                  <p class="card-text text-secondary">{{ $t('annualReport.pageTitle') }}</p>
                  <h4 class="card-title mb-5"><b>{{ list[0]?.annual_report_name }}</b></h4>
                  <p class="card-text text-secondary">
                    <small class="text-muted">
                      <a :href="list[0]?.annual_report_pdf_url" target="_blank">
                        <i class="fa-solid fa-download"></i> {{ $t('annualReport.download') }}
                      </a>
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <div class="row justify-content-center align-items-center mb-5">
          <div class="col-8 col-md-6" v-for="(report, index) in list" :key="index">
            <div class="card border-0 mb-3" style="max-width: 540px;">
              <div class="row g-0">
                <div class="col-12 col-md-6 text-center bg-black justify-content-center align-items-center">
                  <img :src="report.annual_report_img_url" class="img-fluid rounded-start p-3" style="height: 250px;">
                </div>
                <div class="col-md-6 d-flex">
                  <div class="card-body bg-body-docs">
                    <b class="card-text">{{ report.annual_report_name }}</b>
                    <p class="card-text mt-3 text-secondary">
                      <small class="text-muted">
                        <a :href="report.annual_report_pdf_url" target="_blank">
                          <i class="fa-solid fa-download"></i> {{ $t('annualReport.download') }}
                        </a>
                      </small>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <div v-if="isLoading" class="d-flex justify-content-center align-items-center mb-5" style="height: 50px;">
          <div class="spinner-grow custom-spinner" role="status"></div>
        </div>
      </div>
    </div>
  </template>
  
  
<script>
import PublishedDocsInfoTabMenu from '@/components/PublishedDocsInfoTabMenu.vue';
import Highcharts from 'highcharts';
import store from "@/store";
import { mapState } from "vuex";
import { GET_ANNUAL_REPORTS_DATA } from "../../store/actions.type";

export default {
    name: 'Info',
    components: {
        PublishedDocsInfoTabMenu,
    },
    data() {
        return {
            list: [],
            isLoading: false,
        };
    },
    async created() {
        this.isLoading = true;
        await this.init();
        this.isLoading = false;
    },
    watch: {
        '$i18n.locale'(newLang) {
            this.init();
        }
    },
    methods: {
        async init() {
            const lang = this.$i18n.locale || 'th';
            this.list = await store.dispatch(GET_ANNUAL_REPORTS_DATA, lang);
            this.sortListByIdDesc();
        },
        sortListByIdDesc() {
            this.list.sort((a, b) => b.annual_report_id - a.annual_report_id);
        },
    },
};
</script>

<style scoped>
.bg-body-docs{
    background-color: #F2F2F2;
}
h2.mt-5 {
    display: inline-block;
    border-bottom: 3px solid #E87D2E;
    padding-bottom: 5px;
}

.card-pdf {
    box-shadow: 0px 4px 10px 0px #0000000D;
    border: none;
    width: 800px;
}

.card {
    background-color: #F2F2F2;
}

.vertical-line {
    width: 4px;
    background-color: #E87D2E;
    height: 160px;
}

th {
    font-weight: normal;
}

.table {
    margin-bottom: 0;
}
</style>
  